import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import VueAMap from 'vue-amap';
import mapJson from "../dashboard/static/441500.json"; //注意不要和 AMap原始名称覆盖

var amapManager = new VueAMap.AMapManager();
var amap;
import fileTable from "../dashboard/com/fileTable";
import analysis from "../dashboard/com/analysis";
import { querySiteList, queryBigDataById, queryWastDateList, queryWaterCurveAnalysis } from '@/api/api';
import moment from 'moment';
import { getAction } from '@/api/manage';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { appMethod } from '@/mixins/appMethod';
export default {
  name: 'map',
  mixins: [appMethod],
  components: {
    fileTable: fileTable,
    analysis: analysis
  },
  props: {
    showSite: {
      type: Boolean,
      default: true
    } // showRiver: {
    //   type: Boolean,
    //   default: false
    // }

  },
  data: function data() {
    return {
      labelState: false,
      showTab: false,
      dataDetail: ['水库水位', '位移', '渗压', '渗流'],
      selectedTagType: '',
      tagList: [{
        type: 1,
        title: '水库',
        show: true,
        icon: 'icon-shuiyuqingjiancedian',
        siteList: []
      }, {
        type: 2,
        title: '泵站',
        show: true,
        icon: 'icon-bengzhan1',
        siteList: []
      }, {
        type: 3,
        title: '闸站',
        show: true,
        icon: 'icon-dazhongxingshuizha-map',
        siteList: []
      }, {
        type: 4,
        title: '位移',
        show: true,
        icon: 'icon-tangyanbagongcheng',
        siteList: []
      }, {
        type: 5,
        title: '渗压',
        show: true,
        icon: 'icon-yali',
        siteList: []
      }, {
        type: 6,
        title: '渗流',
        show: true,
        icon: 'icon-liuliang1',
        siteList: []
      }],
      showAnalysis: false,
      dateList: [],
      showWindow: false,
      amapManager: amapManager,
      mapStyle: 'amap://styles/darkblue',
      center: [115.361868, 22.840558],
      zoom: 10,
      markerList: [],
      selectedMarkerData: {},
      plugin: [{
        pName: 'MapType',
        defaultType: 1,
        showRoad: true,
        showButton: true,
        showTraffic: false,
        events: {
          init: function init(o) {}
        }
      }],
      column: [{
        code: 'title',
        label: '检测因子'
      }, {
        code: 'value',
        label: '检测值'
      }, {
        code: 'unitName',
        label: '单位'
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    console.log('getAction');
    Vue.ls.set(ACCESS_TOKEN, this.$route.query.token, 7 * 24 * 60 * 60 * 1000);
    window.title = '';
    this.$nextTick(function () {
      // setTimeout(() => {
      //   this.zoom = window.localStorage.getItem('mapZoom') ? window.localStorage.getItem('mapZoom') : 12
      // }, 1000)
      if (_this.showSite) {
        _this.getMarkerData();
      }
    });
  },
  methods: {
    onToChangeName: function onToChangeName() {
      this.labelState = !this.labelState;
      this.initMarker();
    },
    handleNameLabel: function handleNameLabel() {},
    showSetting: function showSetting() {
      this.showTab = !this.showTab;
    },
    onToSelectTag: function onToSelectTag(item) {
      var _this2 = this;

      if (this.selectedTagType === item.type) {
        this.selectedTagType = '';
      } else {
        this.selectedTagType = item.type;
      }

      console.log('this.selectedTagType', this.selectedTagType == '');
      this.markerList.forEach(function (data) {
        if (data.type == item.type || _this2.selectedTagType === '') {
          data.show = true;
        } else {
          data.show = false;
        }
      });
      console.log('markerList', this.selectedTagType);
      console.log('markerList', this.markerList);
    },
    // 标签按钮选中回显状态
    setTagSelected: function setTagSelected(selectedData) {
      return this.selectedTagType === selectedData.type ? '#0ff' : '#fff';
    },
    handlePop: function handlePop(item) {
      console.log('item', item); // this.selectedMarkerData = item

      this.showWindow = true;
      this.getSiteData(item);
    },
    getSiteData: function getSiteData(siteData) {
      var _this3 = this;

      queryBigDataById({
        id: siteData.id
      }).then(function (res) {
        if (res.success) {
          _this3.selectedMarkerData = res.result;
        }
      });
      this.dateList = [];
      var param = siteData.st == 60 && siteData.category == 2 ? {
        st: siteData.st,
        stime: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        etime: moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss'),
        order: 'desc',
        scopeId: siteData.id,
        scope: 1,
        searchCount: true
      } : {
        scopeId: siteData.id,
        st: siteData.st,
        order: 'desc',
        scope: 1,
        searchCount: true
      };
      var url = siteData.st == 60 && siteData.category == 2 ? "online/st".concat(param.st, "/cn2061/") : "/online/st".concat(param.st, "/realtime/");
      getAction(url, param).then(function (res) {
        if (res.success) {
          var dataObj = res.result.records && res.result.records.length > 0 && res.result.records[0].factor ? res.result.records[0].factor : {};
          res.result.query.factors.forEach(function (item) {
            item.value = dataObj[item.code] && dataObj[item.code].value !== '' && dataObj[item.code].value !== null ? dataObj[item.code].value : '';
          });
          _this3.dateList = res.result.query.factors;
        }
      });
    },
    initMarker: function initMarker() {
      var _this4 = this;

      this.markerList.forEach(function (item) {
        if (_this4.labelState) {
          item['label'] = {
            content: item.name,
            offset: [0, -20]
          };
        } else {
          item['label'] = {
            content: '',
            offset: [0, 0]
          };
        }
      });
    },
    getMarkerData: function getMarkerData() {
      var _this5 = this;

      querySiteList({
        // st: 60,
        field: 'id,,mn,name,departName,tenantName,userId_userName,riverName,areaName,status_dictText,action',
        current: 1,
        size: -1,
        searchCount: true
      }).then(function (res) {
        console.log('res', res);

        if (res.success) {
          res.result.records.forEach(function (item) {
            if (item.st == 61 || item.st == 60 && item.category) {
              var type = _this5.handleType(item);

              item.type = type;

              _this5.markerList.push(_objectSpread(_objectSpread({}, item), {}, {
                position: [item.longitude, item.latitude],
                content: "<div title=\"".concat(item.name, "\" style=\"width: 30px;height: 30px;border-radius: 50%;display: flex;align-items: center;justify-content: center;border: 1px solid #00FFE7;background: #fff\"><div style=\"color: #00FFE7;font-size: 20px;margin:0;\" class=\"iconfont ").concat(_this5.tagList[type - 1].icon, "\"></div></div>"),
                label: item.name,
                show: true,
                events: {
                  click: function click() {
                    _this5.handlePop(item);
                  }
                }
              }));
            }

            _this5.initMarker();
          });

          _this5.$emit('siteData', _this5.markerList);

          _this5.$emit('siteTab', _this5.tagList);
        }
      });
    },
    handleType: function handleType(item) {
      if (item.st == 61) {
        return item.category - 0;
      } else {
        return item.category - 0 + 2;
      }
    },
    initMap: function initMap(mapObj) {
      var _this6 = this;

      if (this.$route.query.userName) {
        getAction("/auth/getTenantByUserName", {
          userName: this.$route.query.userName
        }).then(function (res) {
          if (res.success) {
            res.result.mapCenter ? _this6.center = res.result.mapCenter.split(',') : '';
            res.result.zoomLevel ? _this6.zoom = res.result.zoomLevel : '';
          } else {
            _this6.zoom = 12;
          }
        }).catch(function (e) {
          _this6.zoom = 12;
        });
      }

      amap = mapObj;
      this.drawBounds();
    },
    drawBounds: function drawBounds() {
      mapJson.features.forEach(function (item, index) {
        item.geometry.coordinates.forEach(function (item1, index1) {
          var features = item1;

          if (features.length > 0) {
            var outer = [new AMap.LngLat(-360, 90, true), new AMap.LngLat(-360, -90, true), new AMap.LngLat(360, -90, true), new AMap.LngLat(360, 90, true)];
            var inline = features.map(function (area) {
              return area.map(function (info) {
                return new AMap.LngLat(info[0], info[1], true);
              });
            });
            var pathArray = [outer];
            pathArray.push.apply(pathArray, inline);
            var polygon = new AMap.Polygon({
              // 这些就是图形的一些基本样式了，颜色 线条粗细 透明度之类的
              pathL: pathArray,
              //线条颜色，使用16进制颜色代码赋值。默认值为#006600
              strokeColor: '#ffd200',
              strokeWeight: 5,
              //轮廓线透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
              strokeOpacity: 1,
              //多边形填充颜色，使用16进制颜色代码赋值，如：#FFAA00
              fillColor: 'rgba(99,99,99,0)',
              //多边形填充透明度，取值范围[0,1]，0表示完全透明，1表示不透明。默认为0.9
              fillOpacity: 0,
              zIndex: 99999999
            });
            polygon.setPath(pathArray);
            amap.add(polygon);
          }
        });
      });
    }
  }
};